import React, { useRef } from "react";
import ContactForm from './ContactForm';

import { pageMetadata } from "../../config/metadata";
import SEO from "../../Seo";
const Contactlanding = () => {
    const metadata = pageMetadata.contactSeo;
    document.title = metadata.title;
    document.description = metadata.description;
    const contactFormRef = useRef(null);
    const setFormRef = (ref) => {
        contactFormRef.current = ref;
    };

    return (
        <>
         <SEO
        title={metadata.title}
        description={metadata.description}
        keywords={metadata.keywords}
        canonical={metadata.canonical}
        ogTitle={metadata.ogTitle}
        ogDescription={metadata.ogDescription}
        ogImage={metadata.ogImage}
        ogUrl={metadata.ogUrl}
        ogType={metadata.ogType}
        twitterCard={metadata.twitterCard}
        twitterTitle={metadata.twitterTitle}
        twitterDescription={metadata.twitterDescription}
      />
        <div className="contact-container">
            <ContactForm contactFormRef={setFormRef} />
        </div>

        </>

    )
}

export default Contactlanding